const helpers = {
  currencify(number) {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'ILS',
    });

    return formatter.format(number);
  },

   formatTime(isoString) {
    const dateObject = new Date(isoString);
  
    const year = dateObject.getFullYear();
    const month = dateObject.getMonth() + 1; 
    const day = dateObject.getDate();
    const hours = dateObject.getHours();
    const minutes = dateObject.getMinutes();
  
    const formattedTime = `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day} ${hours}:${minutes < 10 ? '0' + minutes : minutes}`;
    return formattedTime;
  },

  formatDate(dateStr) {
    const date = new Date(dateStr);
    
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    const formattedDate = date.toLocaleDateString('en-GB', options);
    
    const [day, month, year] = formattedDate.split(' ');
    const finalFormattedDate = `${day} ${month}, ${year}`;
    
    return finalFormattedDate;
  }
}